// extracted by css-extract-rspack-plugin
export default {"leftColumn":"Aside-module__leftColumn___RJJ4S","top":"Aside-module__top___WIZvd","title":"Aside-module__title___lV_3D"};